{
  "freeList": [
    { "value": "Podcasts, webinars, videos, and tutorials" },
    { "value": "Technical skills assessments" },
    { "value": "Technical and certification digital communities" },
    { "value": "Network automation Learning Path" }
  ],
  "essentialList": [
    { "value": "IT domain fundamentals training" },
    { "value": "Multi-vendor technology training" },
    { "value": "Professional and soft skills training" },
    { "value": "Associate-level certification Learning Paths" },
    { "value": "Self-paced hands-on labs" }
  ],
  "allAccessList": [
    { "value": "All multi-vendor technology training" },
    { "value": "Professional-level certification Learning Paths" },
    { "value": "In-depth Cisco product Learning Paths" },
    { "value": "In-depth Cisco solution Learning Paths" },
    { "value": "All self-paced hands-on labs" },
    {
      "value": "Personalized guidance with AI Learning Experience in Cisco U. (Beta)"
    }
  ]
}
